import React, { useEffect, useState } from "react";
import { CiLocationOn } from "react-icons/ci";
import { IoCall } from "react-icons/io5";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagramSquare } from "react-icons/fa";
import { FaSquareXTwitter } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { scAxiosAdmin } from "../..";

const Footer = () => {
  const [footerData, setFooterData] = useState([]);
  useEffect(() => {
    const footerDataList = {
      ids: [31, 32, 33, 34, 35, 36, 38, 39, 41, 42, 50, 51, 52, 53, 60],
    };
    const getFooterData = (data) => {
      try {
        const req = scAxiosAdmin
          .post(`/settings/get_multiple`, footerDataList, {
            // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
            method: "get",
            headers: {
              Accept: "application/json",
              // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              // console.log('your log output',data)
              // setStaticPageData(data.data.data);
              setFooterData(data.data);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getFooterData();
  }, []);

  return (
    <div>
      <div className="row g-0">
        {/* First Section */}
        <div className="col-12 col-lg-4">
          <div className="accordion-item">
            <div className="hover-trigger" style={{ position: "relative" }}>
              <img
                src="/assets/images/3_1.png"
                width="100%"
                alt=""
                className="image-hover"
              />
              {/* Hover Section */}
              <div className="hover-overlay w-100 h-100">
                {/* Data Section */}
                <div
                  className="p-4"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div className="row row-cols-2 px-0 px-xxl-4">
                    {/* First Row */}
                    <div className="mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start">
                      <h5 className="header-text">United Hospital</h5>
                      {/* {footerData.length > 0 ? footerData[0].value : "10666"} */}
                      {footerData.length > 0 && footerData[4].value
                        ? footerData[4].value
                            .split("<br/>")
                            .map((item, index) => (
                              <p className="normal-text">{item ? item : ""}</p>
                            ))
                        : ""}
                      {/* <p className="normal-text"></p> */}
                      {/* <p className="normal-text">
                        {footerData.length > 0
                          ? footerData[0].value.split("<br/>")[1]
                          : "Dhaka 1212, Bangladesh"}
                      </p>
                      <p className="normal-text">
                        {footerData.length > 0
                          ? footerData[0].value.split("<br/>")[2]
                          : "Cell: +880 1914 001234"}
                      </p> */}
                    </div>
                    <div className="mb-3 mb-xxl-5 d-flex justify-content-start align-items-start ps-3 ps-md-4 ps-lg-5">
                      <div
                        onClick={() =>
                          window.open(
                            footerData.length > 0 && footerData[5].value
                              ? footerData[5].value
                              : "https://maps.app.goo.gl/UJS8gnWhCddNuwDH9"
                          )
                        }
                        className="d-flex flex-column justify-content-start align-items-center"
                      >
                        <CiLocationOn className="text-white locationIcon" />{" "}
                        <span className="normal-text">View on Map</span>
                      </div>
                    </div>{" "}
                    <div className="d-flex flex-column justify-content-start align-items-start">
                      <h5 className="sub-header-text">
                        Chattogram Information Centre
                      </h5>
                      {footerData.length > 0 && footerData[6].value
                        ? footerData[6].value
                            .split("<br/>")
                            .map((item, index) => (
                              <p className="normal-text">{item ? item : ""}</p>
                            ))
                        : ""}
                      {/* <p className="normal-text">
                        23/A, M M Ali Road, Golpahar Moor
                      </p>
                      <p className="normal-text">Mehdibag, Chittagong.</p>
                      <p className="normal-text">Cell: +880 1914 001210</p> */}
                      <div
                        onClick={() =>
                          window.open(
                            footerData.length > 0 && footerData[7].value
                              ? footerData[7].value
                              : "https://maps.app.goo.gl/9XBtAtvFvK3Zcn9R8"
                          )
                        }
                      >
                        <CiLocationOn
                          className="text-white"
                          style={{ fontWeight: 900 }}
                        />{" "}
                        <span className="normal-text">View on Map</span>
                      </div>
                    </div>
                    <div className=" d-flex flex-column justify-content-start align-items-start">
                      <h5 className="sub-header-text">
                        Sylhet Information Centre
                      </h5>
                      {footerData.length > 0 && footerData[8].value
                        ? footerData[8].value
                            .split("<br/>")
                            .map((item, index) => (
                              <p className="normal-text">{item ? item : ""}</p>
                            ))
                        : ""}
                      {/* <p className="normal-text">
                        21 Niloy, Gour Govinda Tila Road
                      </p>
                      <p className="normal-text">
                        (Behind the Muktijoddha Complex, Near Noorjahan Clinic),
                        Chowhatta, Sylhet
                      </p>
                      <p className="normal-text">Cell: +880 1914 001211</p> */}
                      <div
                        onClick={() =>
                          window.open(
                            footerData.length > 0 && footerData[9].value
                              ? footerData[9].value
                              : "https://maps.app.goo.gl/6XrybGQtJXvuzHkK9"
                          )
                        }
                      >
                        <CiLocationOn
                          className="text-white"
                          style={{ fontWeight: 900 }}
                        />{" "}
                        <span className="normal-text">View on Map</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Second Section */}
        <div className="col-12 col-lg-4">
          <div className="accordion-item">
            <div className="hover-trigger" style={{ position: "relative" }}>
              <img
                src="/assets/images/1.png"
                alt=""
                width={"100%"}
                className="image-hover"
              />
              {/* Hover Section */}
              <div className="hover-overlay w-100 h-100">
                {/* Data Section */}
                <div
                  className="p-4"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div className="row row-cols-3 px-0 px-xxl-4">
                    {/* First Row */}
                    <div className="mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start">
                      <h5 className="header-text">Social Page</h5>
                      <Link className="text-decoration-none" to="">
                        {" "}
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/page/brief-history"
                      >
                        <p className="normal-text">Brief History</p>
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/page/mission-statement"
                      >
                        <p className="normal-text">Mission Statement</p>
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/page/board-members"
                      >
                        <p className="normal-text">Board Members</p>
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/page/people-diversity"
                      >
                        <p className="normal-text">People & Diversity</p>
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/page/operation-team"
                      >
                        <p className="normal-text">Operation Team</p>
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/services/corporate-client"
                      >
                        <p className="normal-text">Corporate Client</p>
                      </Link>
                    </div>
                    <div className="mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start">
                      <h5 className="header-text">Gallery</h5>
                      <Link
                        className="text-decoration-none"
                        to="/gallery/photo-gallery"
                      >
                        <p className="normal-text">Photo Gallery</p>
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/gallery/video-gallery"
                      >
                        <p className="normal-text">Video Gallery</p>
                      </Link>
                      <Link
                        className="text-decoration-none"
                        to="/pages/life-at-uhl"
                      >
                        <p className="normal-text">Life at UHL</p>
                      </Link>
                    </div>
                    <div className="mb-3 mb-xxl-5 d-flex flex-column justify-content-start align-items-start">
                      <h5 className="header-text">Social Page</h5>
                      <Link className="text-decoration-none" to="/news">
                        <p className="normal-text">Latest News</p>
                      </Link>
                      <Link className="text-decoration-none" to="/publication">
                        <p className="normal-text">Publication</p>
                      </Link>
                      <Link className="text-decoration-none" to="/news/index">
                        <p className="normal-text">Notice Board</p>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Third Section */}
        <div className="col-12 col-lg-4">
          <div className="accordion-item">
            <div className="hover-trigger" style={{ position: "relative" }}>
              <img
                src="/assets/images/2.png"
                width={"100%"}
                alt=""
                className="image-hover"
              />
              {/* Hover Section */}
              <div className="hover-overlay w-100 h-100">
                {/* Data Section */}
                <div
                  className="p-4"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* First Section: Headphone Icon */}
                  <div className="d-flex align-items-center mb-3">
                    <TfiHeadphoneAlt className="locationIcon" />
                  </div>

                  {/* Second Section: Call Icon and Number */}
                  <a className="text-decoration-none" href="tel:10666">
                    <div className="d-flex align-items-center mb-3">
                      <IoCall size={40} className="header-text me-2" />
                      <h5 className="header-text">
                        {footerData.length > 0 && footerData[0].value
                          ? footerData[0].value
                          : "10666"}
                      </h5>
                    </div>
                  </a>

                  {/* Third Section: Cell and International Numbers */}
                  <div className="d-flex flex-column mb-3 justify-content-start align-items-center gap-0">
                    <h6
                      className="header-text d-flex align-items-center"
                      style={{ width: "fit-content", display: "inline-block" }}
                    >
                      Cell:{" "}
                      <span className="sub-header-text mt-1">
                        {footerData.length > 0 && footerData[1].value
                          ? footerData[1].value
                          : "+880 1914 001234"}
                      </span>{" "}
                    </h6>

                    <h6
                      className="header-text d-flex align-items-center"
                      style={{ width: "fit-content", display: "inline-block" }}
                    >
                      International:{" "}
                      <span className="sub-header-text mt-1">
                        {footerData.length > 0 && footerData[2].value
                          ? footerData[2].value
                          : "+8802-2222-62466"}
                      </span>{" "}
                    </h6>
                  </div>

                  {/* Fourth Section: Repeated Cell and International Numbers */}
                  <div className="d-flex justify-content-center align-items-center">
                    <h6 className="header-text">WhatsApp:</h6>

                    <h6 className="sub-header-text mt-2">
                      {footerData.length > 0 && footerData[3].value
                        ? footerData[3].value
                        : "+880191-4001214"}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex justify-content-center align-items-center py-3"
        style={{ backgroundColor: "#AF9763" }}
      >
        <div className="container flex-column flex-md-row d-flex justify-content-between align-items-center gap-4 gap-md-0">
          <div className="">
            <p className="text-white text-center text-md-left">
              {footerData.length > 0 && footerData[14].value
                ? footerData[14].value
                : `${new Date().getFullYear()} United Hospital Limited. All Rights
              Reserved. Design & Developed with`}
              <span style={{ color: "black" }}> ♥</span> by{" "}
              <a
                className="text-white"
                href="https://www.ethertech.ltd/"
                target="_blank"
                rel="noopener noreferrer"
              >
                EtherTech
              </a>
            </p>
          </div>
          <Link to="/">
            <div className="">
              <img
                style={{ maxWidth: "70px" }}
                className="img-fluid"
                src="/assets/images/white_uhl.png"
                alt=""
                srcset=""
              />
            </div>
          </Link>

          <div className="d-flex justify-content-start align-items-center gap-4">
            <a
              href={
                footerData.length > 0 && footerData[10].value
                  ? footerData[10].value
                  : "https://www.facebook.com/uhlbd/"
              }
              className="text-light lh-1"
              target="_blank"
            >
              <FaFacebookSquare size={isMobile ? 20 : 30} />
            </a>
            <a
              href={
                footerData.length > 0 && footerData[12].value
                  ? footerData[12].value
                  : "https://www.instagram.com/myunitedhospital/"
              }
              className="text-light lh-1"
              target="_blank"
            >
              <FaInstagramSquare size={isMobile ? 20 : 30} />
            </a>
            <a
              href={
                footerData.length > 0 && footerData[11].value
                  ? footerData[11].value
                  : "https://x.com/uhlbd"
              }
              className="text-light lh-1"
              target="_blank"
            >
              <FaSquareXTwitter size={isMobile ? 20 : 30} />
            </a>
            <a
              href={
                footerData.length > 0 && footerData[13].value
                  ? footerData[13].value
                  : "https://www.youtube.com/user/uhlbd"
              }
              className="text-light lh-1"
              target="_blank"
            >
              <IoLogoYoutube size={isMobile ? 20 : 30} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/component/frontend/Footer.js